import { render } from "./MainWorkSchedules.vue?vue&type=template&id=460361f2&scoped=true"
import script from "./MainWorkSchedules.vue?vue&type=script&lang=js"
export * from "./MainWorkSchedules.vue?vue&type=script&lang=js"

import "./MainWorkSchedules.vue?vue&type=style&index=0&id=460361f2&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460361f2"]])

export default __exports__